export default __webpack_public_path__ + "static/media/pulsechain-card.b73ac3ea.png";